export const EmojiCategory = [
    {
        name: 'Professional',
        emojis: ['💼', '👔', '👩‍💼', '👨‍💼', '🏢', '📊', '📈', '📉', '💻', '🖥️', '📱', '⌨️', '🖱️', '📋', '📝', '📄', '📑', '🗂️', '📁', '🗃️', '📂', '🗄️', '📌', '📎', '✂️', '📐', '📏', '🔍', '🔎', '💡']
    },
    {
        name: 'Communication',
        emojis: ['📞', '☎️', '📱', '📧', '✉️', '📨', '📩', '📤', '📥', '📬', '📭', '📮', '🗳️', '✏️', '✒️', '🖋️', '🖊️', '🖍️', '📢', '📣', '📯', '🔔', '🔕', '💬', '💭', '🗯️', '💡', '🎯', '📡', '📺']
    },
    {
        name: 'Safety & Security',
        emojis: ['⚠️', '🚨', '🔒', '🔐', '🛡️', '🔑', '🗝️', '⛑️', '🦺', '🚧', '🚦', '🛑', '⭕', '🚫', '❌', '✅', '☑️', '✔️', '🔴', '🟡', '🟢', '🔵', '🟠', '🟣', '⚪', '⚫', '🔺', '🔻', '🔸', '🔹']
    },
    {
        name: 'Industry & Engineering',
        emojis: ['🏭', '🏗️', '⚙️', '🔧', '🔨', '⛏️', '🪚', '🔩', '⚡', '🔋', '🔌', '💾', '💿', '📀', '🖲️', '⚗️', '🧪', '🔬', '🧬', '💊', '🩹', '🩺', '🏥', '🚀', '🛸', '⚓', '🛠️', '🔬', '📡', '🛰️']
    },
    {
        name: 'Success & Achievement',
        emojis: ['🏆', '🥇', '🥈', '🥉', '🎖️', '🏅', '⭐', '🌟', '✨', '💫', '🎯', '🎪', '🎭', '🎨', '🎼', '🎵', '🎶', '🎤', '🎧', '🎬', '🎮', '🃏', '🎲', '🧩', '🎳', '🎱', '🎪', '🎨', '🖼️', '🎭']
    },
    {
        name: 'Finance & Growth',
        emojis: ['💰', '💵', '💴', '💶', '💷', '💸', '💳', '💎', '⚖️', '📊', '📈', '📉', '💹', '💲', '🏦', '🏧', '💱', '💴', '💵', '💶', '💷', '🪙', '💰', '🤑', '💸', '📊', '📈', '📉', '💹', '💲']
    },
    {
        name: 'Transportation & Logistics',
        emojis: ['🚗', '🚕', '🚙', '🚌', '🚎', '🏎️', '🚓', '🚑', '🚒', '🚐', '🛻', '🚚', '🚛', '🚜', '🏍️', '🛴', '🚲', '🛺', '🚁', '✈️', '🛩️', '🚀', '🛸', '🚢', '⛵', '🚤', '⛴️', '🛳️', '⚓', '🚧']
    },
    {
        name: 'Approval & Feedback',
        emojis: ['👍', '👎', '👌', '✌️', '🤞', '🤝', '👏', '🙌', '👐', '🤲', '🙏', '✊', '👊', '🤛', '🤜', '👋', '🤚', '🖐️', '✋', '🖖', '👆', '👇', '☝️', '👈', '👉', '🤟', '🤘', '🤙', '💪', '🦾']
    }
];